import { ThemeOptions } from "@mui/material";

export const themeMJB : ThemeOptions ={
    palette: {
      primary: {
        light: '#f9e66f',
        main: '#95862d', // couleur principale
        dark: '#95862d',
      },
      secondary: {
        main: '#000000',
        light: '#FFF' // couleur secondaire
      },





    },
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 20, // arrondir les bords
            fontFamily: 'Ubuntu', // changer la police
            label: {
              fontFamily:  'Ubuntu', // changer la police du label
            },
          },
          notchedOutline: {
            '&:hover': {
              borderColor: '#000000', // couleur lors du survol
            },
            '&.Mui-focused': {
              borderColor: '#000000', // couleur lors du focus
            },
          },

        },
      },
    },
  }

  export const themeMJBDark : ThemeOptions ={
    palette: {
      primary: {
        light: '#ffffffb4',
        main: '#ffffffb4', // couleur principale
        dark: '#ffffffb4',
      },
      secondary: {
        main: '#ffffffb4', //
  
      },
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          input: {
            '&::placeholder': {
              color: 'red',  // Couleur du placeholder
              opacity: 1,    // Pleine opacité pour s'assurer que la couleur est visible
            },
          },
        },
      },
      
      MuiOutlinedInput: {
        styleOverrides: {

          
          root: {
            borderRadius: 20, // arrondir les bords
            fontFamily: 'Ubuntu', // changer la police
            label: {
              fontFamily:  'Ubuntu', // changer la police du label
              color: '#ffffffb4',
            },
            

            color: '#ffffffb4',
            backgroundColor: '#ffffff15',

            input: {
              '&::placeholder': {
                color: '#ffffffb4', // couleur du placeholder
              },
            },
            
           
          },
          notchedOutline: {
            borderColor:  'transparent', // couleur par défaut
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor:  '#ffffffb4', // couleur lors du survol
            },

            '&.Mui-focused': {
              borderColor:  '#ffffffb4', // couleur lors du focus
            },
            color: '#ffffffb4',
            
          },


        },
      },
    },
  }
